import { ApiResult, HttpClient } from "../http.js";
import { ShoppingListDto, ShoppingListItemDto, ShoppingListStatus } from "../types/shopping-list.js";

/** A manual item on a project's indkøbsliste (`materials.create`). */
export interface AddShoppingListItemPayload {
  name: string;
  unit: string;
  quantity?: number | null;
  note?: string | null;
}

/** Every field optional. `note` "" clears it; `quantity` only applies to manual rows. */
export interface UpdateShoppingListItemPayload {
  status?: ShoppingListStatus;
  note?: string | null;
  quantity?: number | null;
}

/**
 * A project's indkøbsliste, generated from the converted quote's price-library consumption.
 * Workers (`materials.create`) tick off and add; managers (`materials.edit`) delete and regenerate.
 */
export class ShoppingListApi {
  constructor(private readonly http: HttpClient) {}

  get(projectId: string): Promise<ApiResult<ShoppingListDto>> {
    return this.http.get<ShoppingListDto>(`/api/projects/${encodeURIComponent(projectId)}/shopping-list`);
  }

  addItem(projectId: string, payload: AddShoppingListItemPayload): Promise<ApiResult<ShoppingListItemDto>> {
    return this.http.post<ShoppingListItemDto>(
      `/api/projects/${encodeURIComponent(projectId)}/shopping-list/items`,
      { body: payload },
    );
  }

  /** Recomputes from the source quote; 409 when the project was not created from a quote. */
  regenerate(projectId: string): Promise<ApiResult<ShoppingListDto>> {
    return this.http.post<ShoppingListDto>(
      `/api/projects/${encodeURIComponent(projectId)}/shopping-list/regenerate`,
    );
  }

  updateItem(id: string, payload: UpdateShoppingListItemPayload): Promise<ApiResult<ShoppingListItemDto>> {
    return this.http.patch<ShoppingListItemDto>(`/api/shopping-list-items/${encodeURIComponent(id)}`, { body: payload });
  }

  removeItem(id: string): Promise<ApiResult<boolean>> {
    return this.http.delete<boolean>(`/api/shopping-list-items/${encodeURIComponent(id)}`);
  }
}
